import React, { useState } from 'react'
import { useSelector } from 'react-redux'

// antd
import { Row, Typography, Steps, Spin, Tooltip, Divider } from 'antd'
import { InfoCircleOutlined } from '@ant-design/icons'

// slices
import { projectsState } from './projects.slice'

// components
import InviteMemberSection from './inviteMemberSection'
import NewProjectForm from './newProjectForm'

const FormModal = ({ formType, refreshProject, onCancel }) => {
    const { Title, Text } = Typography

    const { selectedProject, updatedDataStatus, stepProjectData } =
        useSelector(projectsState)

    const [current, setCurrent] = useState(0)

    const onChange = (value) => {
        setCurrent(value)
    }

    // const items = [
    //     {
    //         title: 'Project Details',
    //         content: (
    //             <NewProjectForm
    //                 onCancel={onCancel}
    //                 refreshProject={refreshProject}
    //                 setStep={() => setCurrent(1)}
    //             />
    //         ),
    //     },
    //     {
    //         title: (
    //             <Row
    //                 align={'middle'}
    //                 style={{
    //                     columnGap: '6px',
    //                 }}
    //             >
    //                 <Text
    //                     style={{
    //                         fontSize: '16px',
    //                     }}
    //                 >
    //                     Add People
    //                 </Text>
    //                 <Tooltip title="Only Assigned user can be in the list">
    //                     <InfoCircleOutlined size={10} />
    //                 </Tooltip>
    //             </Row>
    //         ),
    //         content: (
    //             <>
    //                 <InviteMemberSection
    //                     setStep={() => setCurrent(0)}
    //                     onCancel={onCancel}
    //                     refreshProject={refreshProject}
    //                     formType={formType}
    //                 />
    //             </>
    //         ),
    //         disabled:
    //             stepProjectData &&
    //                 Object.keys(stepProjectData).every(
    //                     (data) => stepProjectData[data]?.length > 0
    //                 )
    //                 ? false
    //                 : true,
    //     },
    // ]

    const items = [
        {
            title: (
                <div style={{ textAlign: 'center' }}>
                    {/* <div style={{ height: "23px", color: "#6e6d6d", fontWeight: 500 }}>Step 1</div> */}
                    <div style={{ fontWeight: 700, color: "#030303" }}>Project Details</div>
                </div>
            ),
            content: (
                <NewProjectForm
                    onCancel={onCancel}
                    refreshProject={refreshProject}
                    setStep={() => setCurrent(1)}
                />
            ),
        },
        {
            title: (
                <div style={{ textAlign: 'center' }}>
                    {/* <div style={{ height: "23px", color: "#6e6d6d", fontWeight: 500 }}>Step 2</div> */}
                    <Row
                        align="middle"
                        justify="center"
                        style={{ columnGap: '4px', marginTop: '2px' }}
                    >
                        <span style={{ fontWeight: 700, color: "#030303" }}>Add People</span>
                        <Tooltip title="Only Assigned user can be in the list">
                            <InfoCircleOutlined style={{ color: "#030303" }} />
                        </Tooltip>
                    </Row>
                </div>
            ),
            content: (
                <InviteMemberSection
                    setStep={() => setCurrent(0)}
                    onCancel={onCancel}
                    refreshProject={refreshProject}
                    formType={formType}
                />
            ),
            disabled:
                stepProjectData &&
                    Object.keys(stepProjectData).every((data) => stepProjectData[data]?.length > 0)
                    ? false
                    : true,
        },
    ]

    return updatedDataStatus === 'loading' && selectedProject === undefined ? (
        <div
            style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
            }}
        >
            <Spin size="large" />
        </div>
    ) : (
        <>
            {/* <Row
                align={'middle'}
                // justify={'center'}
                style={{
                    marginBottom: '15px',
                    padding: "0px 24px"
                }}
            >
                <Title level={4} style={{ margin: 0, textAlign: "left" }}>
                    {`${selectedProject ? 'Update' : 'Create'} Project`}
                </Title>
            </Row> */}
            <Divider style={{ margin: "5px 0px 15px" }} />
            {/* <FormContent /> */}
            <Row
                style={{
                    width: '100%',
                    padding: "0px 24px"
                }}
                justify={'center'}
            >
                {!selectedProject && (
                    <Steps
                        current={current}
                        onChange={(val) => {
                            // Prevent clicking disabled steps
                            if (val === 0 || (val === 1 && !items[1].disabled)) {
                                setCurrent(val)
                            }
                        }}
                        items={items}
                        className="project_create_step"
                        labelPlacement="vertical"
                    />
                )}
                <div
                    style={{
                        marginTop: '10px',
                        width: '100%',
                    }}
                >
                    {items[current].content}
                </div>
            </Row>
        </>
    )
    // )
}

export default FormModal
